var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconDigiWallet48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_16983)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7859 6.4646H15.7563C14.096 6.4646 12.75 7.81058 12.75 9.47093V39.5343C12.75 41.1946 14.096 42.5406 15.7563 42.5406H29.7859C31.4462 42.5406 32.7922 41.1946 32.7922 39.5343V9.47093C32.7922 7.81058 31.4462 6.4646 29.7859 6.4646Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7859 6.4646H15.7563C14.096 6.4646 12.75 7.81058 12.75 9.47093V39.5343C12.75 41.1946 14.096 42.5406 15.7563 42.5406H29.7859C31.4462 42.5406 32.7922 41.1946 32.7922 39.5343V9.47093C32.7922 7.81058 31.4462 6.4646 29.7859 6.4646Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 37.387H32.7922V39.5343C32.7922 41.1947 31.4462 42.5407 29.7859 42.5407H15.7563C14.096 42.5407 12.75 41.1947 12.75 39.5343V37.387Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.771 41.2522C23.4929 41.2522 24.0781 40.6753 24.0781 39.9637C24.0781 39.2521 23.4929 38.6753 22.771 38.6753C22.0491 38.6753 21.4639 39.2521 21.4639 39.9637C21.4639 40.6753 22.0491 41.2522 22.771 41.2522Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1567 9.0415H26.2565",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1916_16983",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 17,
    width: 8,
    height: 14
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3656 17.8491L35.0482 22.7848V25.4818L41.3656 30.4175L43 29.5027V18.8512L41.3656 17.8491Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1916_16983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4376 17.1187C41.1078 18.6775 41.9429 21.0158 41.9429 24.1334C41.9429 27.2511 41.1078 29.5894 39.4376 31.1482",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4312 19.123C38.1014 20.2365 38.9365 21.9067 38.9365 24.1336C38.9365 26.3605 38.1014 28.0307 36.4312 29.1442",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3664 22.1294C35.7839 22.5748 35.9927 23.2429 35.9927 24.1336C35.9927 25.0244 35.7839 25.6925 35.3664 26.1378",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_16983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconDigiWallet48);
export default __webpack_public_path__ + "static/media/pictogramBeaconDigiWallet48.1907d5caf6159369fcbefe10d632ac78.svg";
export { ForwardRef as ReactComponent };